'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileTaxesW8', cobCarrierProfileTaxesW8);

	cobCarrierProfileTaxesW8.$inject = [
		'sessionService', 'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService', '$timeout', '$location', 'validationService',
		'$stateParams', 'SSN_PLACEHOLDER', 'SIN_PLACEHOLDER', 'EIN_PLACEHOLDER'
	];

	var sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		$timeout,
		$location,
		validationService,
		$stateParams,
		ssnPlaceholder,
		sinPlaceholder,
		einPlaceholder;
	var subjectMessages, observerMessages;

	function cobCarrierProfileTaxesW8(_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$timeout_,
		_$location_,
		_validationService_,
		_$stateParams_,
		SSN_PLACEHOLDER,
		SIN_PLACEHOLDER,
		EIN_PLACEHOLDER) {
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$timeout = _$timeout_;
		$location = _$location_;
		validationService = _validationService_;
		$stateParams = _$stateParams_;
		ssnPlaceholder = SSN_PLACEHOLDER;
		sinPlaceholder = SIN_PLACEHOLDER;
		einPlaceholder = EIN_PLACEHOLDER;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileTaxesW8.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.ssnPlaceholder = ssnPlaceholder;
			scope.sinPlaceholder = sinPlaceholder;
			scope.einPlaceholder = einPlaceholder;
            
			scope.carrierId = $stateParams.carrierId;
			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				loaded: false
			};

			scope.beneficialOwnerTypes = [
				{ key: '--', value: 'Select' },
				{ key: 'GrantorTrust', value: 'Grantor Trust' },
				{ key: 'Centralbankofissue', value: 'Central bank of issue' },
				{ key: 'Individual', value: 'Individual' },
				{ key: 'Complextrust', value: 'Complex trust' },
				{ key: 'Taxexemptorganization', value: 'Tax-exempt organization' },
				{ key: 'Corporation', value: 'Corporation' },
				{ key: 'Estate', value: 'Estate' },
				{ key: 'Privatefoundation', value: 'Private Foundation' },
				{ key: 'Disregarded', value: 'Disregarded' },
				{ key: 'Government', value: 'Government' },
				{ key: 'Partnership', value: 'Partnership' },
				{ key: 'Internationalorganization', value: 'International organization' },
				{ key: 'Simpletrust', value: 'Simple Trust' }
			];
			scope.stateList = [
				{ key: 'AB', value: 'AB', country: 'Canada' },
				{ key: 'BC', value: 'BC', country: 'Canada' },
				{ key: 'MB', value: 'MB', country: 'Canada' },
				{ key: 'NB', value: 'NB', country: 'Canada' },
				{ key: 'NF', value: 'NF', country: 'Canada' },
				{ key: 'NT', value: 'NT', country: 'Canada' },
				{ key: 'NS', value: 'NS', country: 'Canada' },
				{ key: 'NU', value: 'NU', country: 'Canada' },
				{ key: 'ON', value: 'ON', country: 'Canada' },
				{ key: 'PE', value: 'PE', country: 'Canada' },
				{ key: 'PQ', value: 'PQ', country: 'Canada' },
				{ key: 'SK', value: 'SK', country: 'Canada' },
				{ key: 'YT', value: 'YT', country: 'Canada' }
			];

			scope.setIsDirty = setIsDirty;
			scope.textFieldKeyDown = textFieldKeyDown;
			scope.validateName = validateName;
			scope.validateBeneficialOwner = validateBeneficialOwner;

			scope.validateStreetAddress = validateStreetAddress;
			scope.validateCityAddress = validateCityAddress;
			scope.validateStateAddress = validateStateAddress;
			scope.validatePostalCodeAddress = validatePostalCodeAddress;

			scope.validateMailingStreet = validateMailingStreet;
			scope.validateMailingCity = validateMailingCity;
			scope.validateMailingState = validateMailingState;
			scope.validateMailingPostalCode = validateMailingPostalCode;

			scope.validateSsn = validateSsn;
			scope.validateEin = validateEin;
			scope.validateBn = validateBn;
			scope.validateSin = validateSin;

			scope.mailingSameAsPermanentChange = mailingSameAsPermanentChange;
			scope.mailingStateChange = mailingStateChange;
			scope.goToTab = goToTab;
			scope.onForceGo = onForceGo;

			registerObserverHandlers();
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_W8_LOADED, handler: loadData },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event, next, current) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!
							confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function loadData(data) {
			scope.m.loaded = true;

			scope.m.beneficialOwnerType = data.beneficialOwnerType;
			scope.m.cityAddress = data.city;
			scope.m.countryAddress = 'Canada';
			scope.m.ein = data.ein;
			scope.m.ssn = data.ssn;
			scope.m.sin = data.sin;
			scope.m.bn = data.bn;
			scope.m.formYear = data.formYear;
			scope.m.incorporationCountry = 'Canada';
			scope.m.mailingSameAsPermanent = data.mailingSameAsPermanent;
			scope.m.mailingCity = data.mailingCity;
			if (data.mailingState)
				scope.m.mailingCountry = 'Canada';

			scope.m.mailingPostalCode = data.mailingPostalCode;
			scope.m.mailingState = data.mailingState;
			scope.m.mailingStreet = data.mailingStreet;
			scope.m.name = data.name;
			scope.m.postalCodeAddress = data.postalCode;
			scope.m.stateAddress = data.state;
			scope.m.streetAddress = data.streetAddress;

			var navState = sessionService.getCarrierNavState();
			if (!scope.m.ein && !scope.m.ssn && !scope.m.sin && !scope.m.bn) {
				if (navState && navState.taxInfoComplete) {
					scope.m.ein = '*********';
					scope.m.ssn = '*********';
					scope.m.sin = '*********';
					scope.m.bn = '*********';
				}
			}
		}

		function saveData(callback) {
			if (!scope.m.loaded)
				return;
			if (scope.m.isDirty) {
				if (formIsValid()) {

					var mailingAddress, mailingCity, mailingState, mailingPostalCode, mailingCountry;
					if (scope.m.mailingSameAsPermanent) {
						mailingAddress = scope.m.streetAddress;
						mailingCity = scope.m.cityAddress;
						mailingState = scope.m.stateAddress;
						mailingPostalCode = scope.m.postalCodeAddress;
						mailingCountry = scope.m.countryAddress;
					} else {
						mailingAddress = scope.m.mailingStreet;
						mailingCity = scope.m.mailingCity;
						mailingState = scope.m.mailingState;
						mailingPostalCode = scope.m.mailingPostalCode;
						mailingCountry = scope.m.mailingCountry;
					}

					var tin, federalTaxType;
					if (scope.m.ein) {
						tin = scope.m.ein;
						federalTaxType = 'EIN';
					} else {
						tin = scope.m.ssn;
						federalTaxType = 'SSN';
					}

					var foreignTaxId, foreignTaxIdType;
					if (scope.m.bn) {
						foreignTaxId = scope.m.bn;
						foreignTaxIdType = 'BN';
					} else {
						foreignTaxId = scope.m.sin;
						foreignTaxIdType = 'SIN';
					}

					carrierRegistrationService.updateW8TaxInformation(scope.m.name,
						scope.m.beneficialOwnerType,
						scope.m.streetAddress,
						scope.m.cityAddress,
						scope.m.stateAddress,
						scope.m.postalCodeAddress,
						scope.m.countryAddress,
						mailingAddress,
						mailingCity,
						mailingState,
						mailingPostalCode,
						mailingCountry,
						tin,
						federalTaxType,
						foreignTaxId,
						foreignTaxIdType,
						scope.carrierId)
						.then(function() {
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
									'taxes');
							if (typeof (callback) === 'function')
								callback();
						});

				} else {
					// invalid form
					setSectionMessage(true);
					scope.pendingCallback = callback;

					$timeout(function() {
						scope.ux_requirement_hack_for_scrolling = true;
						$('.profile-tax')
							.animate({
								scrollTop: $('#error-summary').offset().top
							},
							200);
						setIsDirty();
					},
					1);
				}
			} else {
				setSectionMessage(false);
				if (typeof (callback) === 'function')
					callback();
			}
		}

		function textFieldKeyDown(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			var isShift = !!event.shiftKey;

			if (isShift) {
				switch (charCode) {
				case 220: // | character
				case 222: // "
					event.preventDefault();
				}
			}
		}

		function formIsValid() {
			validateName();
			validateBeneficialOwner();
			validateStreetAddress();
			validateCityAddress();
			validateStateAddress();
			validatePostalCodeAddress();
			validateMailingStreet();
			validateMailingCity();
			validateMailingState();
			validateMailingPostalCode();
			validateSsn();
			validateEin();
			validateBn();
			validateSin();

			if (scope.m.nameError ||
                scope.m.beneficialOwnerError ||
                scope.m.streetAddressError ||
                scope.m.cityAddressError ||
                scope.m.stateAddressError ||
                scope.m.postalCodeAddressError ||
                scope.m.mailingStreetError ||
                scope.m.mailingCityError ||
                scope.m.mailingStateError ||
                scope.m.mailingPostalCodeError ||
                scope.m.ssnError ||
                scope.m.einError ||
                scope.m.bnError ||
                scope.m.sinError ||
                scope.m.foreignTaxIdError ||
                scope.m.taxpayerIdError) {
				return false;
			} else {
				return true;
			}
		}

		function validateName() {
			if (scope.m.name === null || scope.m.name === '') {
				scope.m.nameError = 'Valid input is required';
			} else {
				scope.m.nameError = '';
			}
		}

		function validateBeneficialOwner() {
			if (scope.m.beneficialOwnerType && scope.m.beneficialOwnerType !== '--') {
				scope.m.beneficialOwnerError = '';
			} else {
				scope.m.beneficialOwnerError = 'Please select an option';
			}
		}

		function validateStreetAddress() {
			if (!scope.m.streetAddress) {
				scope.m.streetAddressError = 'Valid input is required';
			} else {
				scope.m.streetAddressError = '';
			}
		}

		function validateCityAddress() {
			if (scope.m.cityAddress === null || scope.m.cityAddress === '') {
				scope.m.cityAddressError = 'Valid input is required';
			} else {
				scope.m.cityAddressError = '';
			}
		}

		function validateStateAddress() {
			if (scope.m.stateAddress === '--') {
				scope.m.stateAddressError = 'Valid input is required';
			} else {
				scope.m.stateAddressError = '';
			}
		}

		function validatePostalCodeAddress() {
			if (!validationService.isValidCanadianPostalCode(scope.m.postalCodeAddress)) {
				scope.m.postalCodeAddressError = 'Valid input is required';
			} else {
				scope.m.postalCodeAddressError = '';
			}
		}

		function validateMailingStreet() {
			if (!scope.m.mailingStreet && !scope.m.mailingSameAsPermanent) {
				scope.m.mailingStreetError = 'Valid input is required';
			} else {
				scope.m.mailingStreetError = '';
			}
		}

		function validateMailingCity() {
			if (!scope.m.mailingCity && !scope.m.mailingSameAsPermanent) {
				scope.m.mailingCityError = 'Valid input is required';
			} else {
				scope.m.mailingCityError = '';
			}
		}

		function validateMailingState() {
			if (!scope.m.mailingState && !scope.m.mailingSameAsPermanent) {
				scope.m.mailingStateError = 'Valid input is required';
			} else {
				scope.m.mailingStateError = '';
			}
		}

		function validateMailingPostalCode() {
			var isValidZip = /^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i
				.test(scope.m.mailingPostalCode);

			if (!isValidZip && !scope.m.mailingSameAsPermanent) {
				scope.m.mailingPostalCodeError = 'Valid input is required';
			} else {
				scope.m.mailingPostalCodeError = '';
			}
		}

		function validateSsn() {
			if (scope.m.ssn && scope.m.ssn.toString().length !== 9) {
				scope.m.ssnError = 'Valid input is required';
			} else {
				scope.m.ssnError = '';
			}

			validateTaxpayerId();
		}

		function validateEin() {
			if (scope.m.ein && scope.m.ein.toString().length !== 9) {
				scope.m.einError = 'Valid input is required';
			} else {
				scope.m.einError = '';
			}

			validateTaxpayerId();
		}

		function validateTaxpayerId() {

			if (scope.m.ein && scope.m.ssn) {
				scope.m.taxpayerIdError = 'Only one TIN allowed';
			} else {
				scope.m.taxpayerIdError = '';
			}
		}

		function validateBn() {
			scope.m.bnError = '';
			validateForeignTaxId();
		}

		function validateSin() {
			if (scope.m.sin && scope.m.sin.toString().length !== 9) {
				scope.m.sinError = 'Valid input is required';
			} else {
				scope.m.sinError = '';
			}
            
			validateForeignTaxId();
		}

		function validateForeignTaxId() {
			if (scope.m.bn && scope.m.sin)
				scope.m.foreignTaxIdError = 'Only one Foreign Tax ID allowed';
			else if (!scope.m.bn && !scope.m.sin)
				scope.m.foreignTaxIdError = 'Valid input is required';
			else
				scope.m.foreignTaxIdError = '';
		}

		function mailingSameAsPermanentChange() {
			if (!scope.m.mailingSameAsPermanent) {

				scope.m.mailingCity = '';
				scope.m.mailingCountry = '';
				scope.m.mailingPostalCode = '';
				scope.m.mailingState = '';
				scope.m.mailingStreet = '';
			}
		}

		function mailingStateChange() {
			if (scope.m.mailingState)
				scope.m.mailingCountry = 'Canada';
			else
				scope.m.mailingCountry = '';
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function setSectionMessage(show) {
			scope.m.showSectionMessage = show;
			if (show) {
				$timeout(function () {
					$('.carrier-profile-wrapper')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
				},
				10);
			}
		}
	}

})();
